import React, { useEffect, useRef, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { convertToArabicNumbers, GetAppText, ValidationErrors } from "../../../utils";

import { ButtonComponent } from "../../components/ButtonComponent";

import {ReactComponent as Texture} from "../../../assets/svgs/texture3.svg"
import { modalHandler } from "../../../store/slices/modalSlice";
import SvgComponent from "../../components/SvgComponent";
import Dropdown from "../../components/Dropdown";
import { apiRoutes } from "../../../apis/routes";
import { postRequest } from "../../../apis/methods";
import { dataHandler } from "../../../store/slices/dataSlice";
import { AlertComponent } from "../../components/AlertComponent";
import { AuthModalHeader } from "../../components/Modal/AuthModalHeader";
import { isFirebasePhoneAuthEnabled } from "../../../firebase/config";
import {
  formatPhoneE164,
  getFirebaseAuthErrorText,
  sendPhoneOtp,
} from "../../../firebase/phoneAuth";
// import countryData from '../../../assets/countryData.json';
export const Login = ({ onClose }) => {
  const language = useSelector((state) => state.language.value);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState('+973');
  const [selectedValue2, setSelectedValue2] = useState(1);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState("");
  // const [countryData, setCountryData] = useState("");
  const[digitLenght,setDigitLenght]=useState(8)
  const countryData = useSelector((state) => state.country.value);



  const dispatch = useDispatch();
  const handleSignup=()=>{
    // navigate(`/signup`);
    dispatch(modalHandler("SignupModal"));
}

const handler=()=>{

  setIsDropdownOpen(!isDropdownOpen);
}
const inputRef = useRef(null);

useEffect(() => {
  inputRef.current.focus();

}, []);

const handleSubmit = async() => {
  // const formattedPhone = Number(selectedValue.replace('+', ''));

  // const number=Number(phoneNumber)
  // const combinedPhone = `${formattedPhone}${number}`; 
 // Map Arabic digits to English digits


// Convert phoneNumber to English if it's in Arabic
const englishPhoneNumber = convertToArabicNumbers(phoneNumber);

// Remove '+' from selectedValue and convert to number
const formattedPhone = Number(selectedValue.replace("+", ""));

// Ensure phoneNumber is a valid number
const number = Number(englishPhoneNumber);

const combinedPhone = `${formattedPhone}${number}`;


  const data={
    country_id:selectedValue2,
    phone: Number(combinedPhone),
    // phone_number: phoneNumber,

  }
  setLoading(true)
  if(selectedValue && phoneNumber)
  {
    const phoneE164 = formatPhoneE164(selectedValue, englishPhoneNumber);

    try {
      if (isFirebasePhoneAuthEnabled()) {
        await sendPhoneOtp(phoneE164);
        setLoading(false);
        dispatch(
          dataHandler({
            ...data,
            phoneE164,
            useFirebase: true,
          })
        );
        dispatch(modalHandler("OtpModal"));
        return;
      }

      const response = await postRequest(apiRoutes.login, data);
      if (response.status === "success") {
        setLoading(false);
        dispatch(dataHandler(data));
        dispatch(modalHandler("OtpModal"));
      } else {
        let error = "";
        if (
          response?.data?.message.includes(
            ValidationErrors.phoneNumber.notComplete
          )
        ) {
          error = GetAppText("phone_not_valid");
        } else if (
          response?.data?.message.includes(
            ValidationErrors.phoneNumber.notExists
          )
        ) {
          error = GetAppText("phone_not_associated");
        } else {
          error = response?.data?.message?.replace(/-/g, " ");
        }
        setAlert(error);
        // setTimeout(() => {
        //   setAlert("");
        // }, [2000]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (isFirebasePhoneAuthEnabled()) {
        setAlert(getFirebaseAuthErrorText(GetAppText, error));
        setTimeout(() => setAlert(""), 2000);
      } else {
        console.error("Error fetching data:", error);
      }
      if (process.env.NODE_ENV === "development") {
        console.error("[Login Firebase]", error?.code, error?.message);
      }
    }
  }
  else{
    setLoading(false)
    setAlert(GetAppText("phone_req"))
    setTimeout(()=>{
      setAlert("")
    },[2000])
  }
   
      // Here, you can send the payload to an API or perform any other action needed.
    };

  
const handleSelect = (value) => {
  setDigitLenght(value?.phone_digits)
  setSelectedValue(value?.phone_code);
  setSelectedValue2(value?.id)
  setPhoneNumber('')
  setIsDropdownOpen(false);
  inputRef.current.focus();
};

// const handleInputChange = (e) => {
//   const value = e.target.value;

//   // Allow only numbers and limit to 8 digits
//   const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
//   if (numericValue.length <= digitLenght) {
//     setPhoneNumber(numericValue);
//   }
// };

const handleInputChange = (e) => {
  let value = e.target.value;

  // ✅ Convert Arabic (٠١٢٣٤٥٦٧٨٩) and Urdu (۰۱۲۳۴۵۶۷۸۹) digits to English (0–9)
  const digitMap = {
    // Arabic-Indic
    "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
    "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
    // Urdu (Eastern Arabic-Indic)
    "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
    "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9"
  };

  // Replace all Arabic/Urdu digits with English digits
  value = value.replace(/[٠-٩۰-۹]/g, (d) => digitMap[d]);

  // ✅ Allow only English digits and limit length
  const numericValue = value.replace(/[^0-9]/g, "");
  if (numericValue.length <= digitLenght) {
    setPhoneNumber(numericValue);
  }
};

// const handleInputChange = (e) => {
//   let value = e.target.value;

//   // If language is Arabic, convert Arabic digits back to English for processing
//   // if (language === "_ar") {
//   //   value = value
//   //     .split("")
//   //     .map((char) => {
//   //       const index = arabicDigits.indexOf(char);
//   //       return index > -1 ? englishDigits[index] : char;
//   //     })
//   //     .join("");
//   // }

//   // Remove non-numeric characters and limit to 8 digits
//   const numericValue = value.replace(/[^0-9]/g, "");
//   if (numericValue.length <= digitLenght) {
//     // if (language === "_ar") {
//     //   // Convert English digits to Arabic digits for display
//     //   const arabicValue = numericValue
//     //     .split("")
//     //     .map((digit) => arabicDigits[Number(digit)])
//     //     .join("");
//     //     console.log("arabicValue",arabicValue)
//     //   setPhoneNumber(arabicValue);
//     // } 
//     // else {
//       setPhoneNumber(numericValue);
//     // }
//   }
// };
const handleKeyDown = (event) => {
  if (["e", "E", ".", "-", "+"].includes(event.key)) {
    event.preventDefault();
  }
  if (event.key === 'Enter') {
    handleSubmit(); // Call the handleSubmit function when Enter key is pressed
  }
};

  return (
 <>
      <div
        className={`bg-secondary_green relative w-full rounded-lg p-6  ${
          language === "_ar" ? "text-right" : "text-left"
        }`}
      >
         <div className="absolute z-50 top-0 left-0">
     <Texture className="object-cover"/>
      </div>
      <div className="space-y-4">
        <AuthModalHeader
          title={GetAppText("login")}
          onClose={onClose}
          language={language}
        />
        <div className=" w-full">
          <div className="flex flex-col space-y-4">
            <div className="flex flex-col space-y-2 relative mb-14">
              <h1 className="text-white text-F14">{GetAppText("phone")}</h1>
              {/* <InputComponent /> */}
              <div>
          <div className="flex items-center  py-1 w-full bg-white border-2 border-borderColor absolute z-50 rounded-lg ">
            <div onClick={handler} className="flex cursor-pointer items-center px-2.5 space-x-2 border-e border-e-borderColor">
              <div className="text-sm">
                {/* {selectedValue} */}
                {selectedValue}
                {/* {language==="_ar"?convertToNumbersInArabic(selectedValue):convertToArabicNumbers(selectedValue)} */}
              </div>
            <SvgComponent
                      name={"ChevronDown"}
                      className={`w-2.5 h-1.5`}
                      stroke={"black"}
                      fill={"none"}
                    />
            </div>
                          <input
                           onKeyDown={handleKeyDown}
                           type={language === "_ar"?"text":"text"}
                    id={"phone"}
                    value={phoneNumber}
                    onChange={handleInputChange}
                    className={`block no-spinner w-full border-none focus:border-borderColor focus:outline-none focus:ring-0  placeholder:text-F14 text-sm placeholder:text-lightTextColor ${
                      language === "_ar" ? "pe-2 text-right" : "ps-3"
                    } `}
                   
                    name={"phone"}
                    ref={inputRef}
                  />
                        
                  </div>
                  {isDropdownOpen&& <Dropdown phone={true} mainStyle={`w-full mt-14 !h-[200px]`}  handleSelect={handleSelect}  isOpen={isDropdownOpen} options={countryData} setIsDropdownOpen={setIsDropdownOpen} />}
                
                  </div>
            </div>
            {/* <div className="flex flex-col space-y-2">
              <h1 className="text-white text-F14">{GetAppText("password")}</h1>
              <InputComponent 
              name={"password"}
              type={isPasswordVisible ? "text" : "password"}
              toggleVisibility={
                () => setIsPasswordVisible(!isPasswordVisible)
               
              }
              isPasswordVisible={ isPasswordVisible 
              }
              
              />
            </div> */}
          </div>
          {/* <div className={`pt-4 flex  ${language === "_ar" ?"flex-row-reverse":"" } `} onClick={()=>{ dispatch(modalHandler("ResetModal"))}}>
            <h1 className="text-white w-fit text-F11  hover:underline cursor-pointer">
              {GetAppText("forgotPassword")}
            </h1>
          </div> */}
          {alert&&<AlertComponent text={alert} isArb={false} svgName={"Warning"} svgColor={"#E94747"} styles={"!text-errorColor !bg-alertErrorBg !mt-5"}/>}
          <div className="pt-4 w-full"> 
            <div className="space-y-4 w-full">
              <ButtonComponent disabled={loading}  loading={loading} styles={"!w-full !normal-case !py-2.5"} onClick={handleSubmit} title={GetAppText("login")} />
              {/* <div className="flex justify-center w-full">
                <div
                  onClick={handleSignup}
                  className={`text-white text-F16 gap-1 mt-1 hover:underline cursor-pointer inline-flex items-center ${
                    language === "_ar" ? "flex-row-reverse" : ""
                  }`}
                >
                  <span>{GetAppText("have_an_account")}</span>
                  <span className="font-bold">{GetAppText("login_acc")}</span>
                </div>
              </div> */}


              <ButtonComponent styles={"!w-full !normal-case !py-2.5"} onClick={handleSignup} title={GetAppText("createNewAccount")} type="transparent"/>
            </div>
          </div>
        </div>
        </div>
      </div>

</>
  );
};
